import { ActionTree, Commit } from 'vuex';
import { ILookupResult } from '../shared-types';
import { IFundHistoryState } from './types';
import { FundHistoryCache } from './utils';

function loadFromCache(commit: Commit, getters: any) {
  const cacheSuffix = getters.cacheSuffix + getters.businessCode;
  const cache = new FundHistoryCache({ keySuffix: cacheSuffix });
  const cachedFundHistoryItems = cache.get();
  commit('setSelectedResultIndex', -1);
  commit('items', cachedFundHistoryItems);
}
function addToCache(commit: Commit, getters: any, item: ILookupResult) {
  const cacheSuffix = getters.cacheSuffix + getters.businessCode;
  const cache = new FundHistoryCache({ keySuffix: cacheSuffix });
  let cachedFundHistoryItems = getters.items as ILookupResult[];
  cachedFundHistoryItems = cachedFundHistoryItems.filter(
    (existing) =>
      !(
        existing.label === item.label &&
        existing.sublabel === item.sublabel &&
        existing.href === item.href
      )
  );
  item.lastUsed = new Date();
  cachedFundHistoryItems.unshift(item);
  try {
    cachedFundHistoryItems = cachedFundHistoryItems.sort(
      (a, b) => (b.lastUsed?.getTime() || 0) - (a.lastUsed?.getTime() || 0)
    );
  } catch {}
  cache.set(cachedFundHistoryItems);
  commit('setSelectedResultIndex', -1);
  commit('items', cachedFundHistoryItems);
}

const actions: ActionTree<IFundHistoryState, any> = {
  selectPreviousResult({ commit, getters }) {
    const results = getters.items;
    let current = getters.selectedResultIndex;
    if (current < 0) {
      current = results?.length || -1;
    }
    if (current > 0) {
      commit('setSelectedResultIndex', current - 1);
    } else {
      commit('setSelectedResultIndex', -1);
    }
  },
  selectNextResult({ commit, getters }) {
    const current = getters.selectedResultIndex;
    const results = getters.items;
    const upperBound = results?.length || 0;
    if (current < upperBound - 1) {
      commit('setSelectedResultIndex', current + 1);
    } else {
      commit('setSelectedResultIndex', -1);
    }
  },
  invokeActionOnSelectedResult({ getters, commit }) {
    const result: ILookupResult = getters.selectedResult;
    if (result) {
      const { href, target } = result;
      window.open(href, target);
    }
  },
  load({ commit, getters }) {
    loadFromCache(commit, getters);
  },
  add({ commit, getters }, item: ILookupResult) {
    addToCache(commit, getters, item);
  },
};

export default actions;
